var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeometryDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12189 8946",
    role: "img",
    "aria-label": "Diagrama de geometr\\xEDa del cuadro",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M 531 7063 L 3953 4801 4608 4728 4072 3164 4395 3056 4685 3934 C 4685 3934 7258 2288 7470 2138 7795 1906 8166 1806 8166 1806 L 9108 1476 9069 1404 9575 1132 10074 2068 9560 2344 C 9560 2344 9543 2290 9501 2265 9459 2240 9343 2315 9217 2390 9092 2465 9026 2616 9026 2616 L 6406 6913 6322 6988 6364 7072 C 6364 7072 6095 7617 6039 7706 5978 7802 5805 7927 5561 7933 5311 7940 4865 7893 4721 7839 4385 7714 4350 7670 4275 7545 4200 7420 4303 7204 4303 7204 L 4447 6985 4387 6997 C 4387 6997 4235 7162 4145 7305 4091 7392 3911 7380 3911 7380 L 540 7547 C 540 7547 150 7462 285 7276 332 7213 531 7063 531 7063 Z M 677 7276 L 3808 7076 4466 6544 C 4466 6544 4538 6500 4594 6513 4651 6525 4832 6610 4832 6610 L 4854 5648 C 4854 5648 4842 5554 4798 5386 4754 5217 4685 5010 4685 5010 L 4016 5091 677 7276 Z M 5192 6169 C 5198 6237 5217 6369 5305 6388 5392 6406 5689 6375 5689 6375 5689 6375 5821 6388 5962 6125 6112 5842 8158 2588 8158 2588 8158 2588 8246 2395 8333 2363 8421 2332 8508 2257 8508 2257 L 8433 2144 C 8433 2144 8377 2107 8164 2169 7951 2232 7582 2451 7150 2726 6719 3001 4789 4239 4789 4239 4789 4239 5080 5149 5168 5400 5256 5650 5186 6100 5192 6169 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 9863 2282 L 11938 7202",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 3707 353 L 3707 1253",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 9217 350 L 9217 1253",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 9112 539 L 3812 539",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 9087 503 L 9217 539 9087 573 9087 503 Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 3837 503 L 3707 539 3837 573 3837 503 Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 5231 782 L 5231 7282",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 5231 7351 L 5231 8330",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 9112 967 L 5336 967",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 9087 932 L 9217 966 9087 1002 9087 932 Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 5361 932 L 5231 966 5361 1002 5361 932 Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 3768 1594 L 3784 1640",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 3813 1729 L 3918 2047",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 3932 2091 L 5876 8016",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 5889 8061 L 5904 8106",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 9205 1294 L 3708 1294 5231 7302",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 3979 7731 L 5158 7333",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 5390 7245 L 6849 6790",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 5423 7271 L 5289 7276 5403 7204 5423 7271 Z",
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 2725 3631 L 3970 3206",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 2936 3679 L 4127 7579",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 2909 3713 L 2905 3579 2977 3693 2909 3713 Z",
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 4086 7565 L 4158 7680 4153 7545 4086 7565 Z",
    fill: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 5289 7309 L 8889 7309",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 7460 1380 L 7460 7204",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 7425 1405 L 7461 1275 7495 1405 7425 1405 Z",
    fill: "currentColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 7425 7179 L 7461 7309 7495 7179 7425 7179 Z",
    fill: "currentColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 476 7365 L 476 8646",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 11939 7219 L 11939 8598",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 11834 8455 L 581 8455",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 11809 8420 L 11939 8455 11809 8490 11809 8420 Z",
    fill: "currentColor"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 606 8420 L 476 8455 606 8490 606 8420 Z",
    fill: "currentColor"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 8168 7202 L 11938 7202",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 8352 6596 L 8352 7095",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 8318 7072 L 8353 7202 8388 7072 8318 7072 Z",
    fill: "currentColor"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 8352 7915 L 8352 7416",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 8388 7441 L 8353 7311 8318 7441 8388 7441 Z",
    fill: "currentColor"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 11539 6563 C 11349 6677 11221 6870 11189 7090",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 11502 6544 L 11633 6515 11534 6607 11502 6544 Z",
    fill: "currentColor"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 11158 7063 L 11182 7195 11228 7069 11158 7063 Z",
    fill: "currentColor"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 5132 8195 L 595 8196",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 5108 8160 L 5239 8196 5108 8231 5108 8160 Z",
    fill: "currentColor"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 620 8161 L 490 8197 620 8231 620 8161 Z",
    fill: "currentColor"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 4012 1949 C 4234 1856 4391 1654 4428 1415",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 4046 1974 L 3912 1983 4024 1907 4046 1974 Z",
    fill: "currentColor"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 4459 1443 L 4436 1310 4389 1437 4459 1443 Z",
    fill: "currentColor"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 10086 2047 L 10496 1831",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 9592 1132 L 10013 907",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 9905 1093 L 10287 1801",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 9887 1131 L 9855 1000 9948 1099 9887 1131 Z",
    fill: "currentColor"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 10245 1797 L 10338 1895 10306 1764 10245 1797 Z",
    fill: "currentColor"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 5959 7871 C 6129 7781 6250 7616 6282 7426",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 18
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 5995 7891 L 5862 7912 5967 7827 5995 7891 Z",
    fill: "currentColor"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 6312 7453 L 6290 7321 6242 7446 6312 7453 Z",
    fill: "currentColor"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 3754,
    y: 6097,
    fontSize: 420,
    fontWeight: 700,
    fill: "currentColor"
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 2273,
    y: 8070,
    fontSize: 420,
    fontWeight: 700,
    fill: "currentColor"
  }, "J")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 6325,
    y: 8850,
    fontSize: 420,
    fontWeight: 700,
    fill: "currentColor"
  }, "I")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 7868,
    y: 7275,
    fontSize: 420,
    fontWeight: 700,
    fill: "currentColor"
  }, "H")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 11414,
    y: 7136,
    fontSize: 420,
    fontWeight: 700,
    fill: "currentColor"
  }, "E")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 7089,
    y: 3578,
    fontSize: 420,
    fontWeight: 700,
    fill: "currentColor"
  }, "C")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 10223,
    y: 1491,
    fontSize: 420,
    fontWeight: 700,
    fill: "currentColor"
  }, "G")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 3913,
    y: 1764,
    fontSize: 420,
    fontWeight: 700,
    fill: "currentColor"
  }, "F")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 5801,
    y: 503,
    fontSize: 420,
    fontWeight: 700,
    fill: "currentColor"
  }, "D")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 8091,
    y: 932,
    fontSize: 420,
    fontWeight: 700,
    fill: "currentColor"
  }, "B")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometryDiagram);
export default __webpack_public_path__ + "static/media/geometry-diagram.3387335f505738827342eb40950d97bc.svg";
export { ForwardRef as ReactComponent };